<template>
  <v-line v-if="!getStyleEdition" :zIndex='2' :config="configLine"></v-line>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Link',
  props: ['tables'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      getStyleEdition: 'newRooms/getStyleEdition'
    }),
    configLine: function () {
      let pointsArray = []
      this.tables.forEach((table) => {
        pointsArray.push(table.x)
        pointsArray.push(table.y)
      })
      return {
        points: pointsArray,
        stroke: '#FFFFFF',
        strokeWidth: 3,
        opacity: 0.5,
        listening: false
      }
    }
  }
}
</script>

<style scoped></style>
